import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "../../common/Hooks";

const LandingPage = ({
    children
}) => {
    const query = useQuery();
    const [translate] = useTranslation();

    const renderTitle = useMemo(() => {
        const guestMode = query.get("guestMode");

        if (guestMode) {
            return <strong>{translate("OTM_LAUNCHING_TRY_IT")}</strong>
        }

        return <strong>{process.env.REACT_APP_PRODUCT_NAME}</strong>
    }, [query, translate]);

    return (
        <div className="h-100">
            <div className="container mt-xxl-5 pt-xxl-5 pt-3 mt-3 d-flex justify-content-center">
                <div className="px-3 px-md-5 py-5 bg-white rounded d-flex flex-grow-1 flex-md-grow-0 flex-column align-items-center justify-content-center">
                    <div>
                        <img src="/favicon.svg" className="favicon" alt="OnTheMove" />
                    </div>
                    <div className="text-center">
                        <label className="display-6 mt-2">
                            {renderTitle}
                        </label>
                    </div>
                    <div className="mt-4 w-100">
                        {children}
                    </div>
                </div>
            </div>
            <div style={{ position: "fixed", bottom: "20px", right: "20px", textAlign: "end" }}>
                <a href={process.env.REACT_APP_OWN_WEBSITE} className="text-secondary">onthemovesw.com</a>
                <div>
                    <label>For support, email <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}?subject=Request Support`} className="text-secondary">{process.env.REACT_APP_SUPPORT_EMAIL}</a></label>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;